import React, { useState } from "react";
import ParticleBackground from "../components/ParticleBackground";
import {
  FaCalendarAlt,
  FaClock,
  FaExclamationTriangle,
  FaSearch,
  FaArrowLeft,
  FaDesktop,
  FaGraduationCap,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const ExamDateSheet = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const dateSheetData = [
    { no: "01", course: "Full Stack Digital Marketing & AI", date: "16 Nov 2026", day: "Monday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "02", course: "Artificial Intelligence", date: "17 Nov 2026", day: "Tuesday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
    { no: "03", course: "IELTS Preparation Training", date: "18 Nov 2026", day: "Wednesday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "04", course: "Video Editing & Animation", date: "19 Nov 2026", day: "Thursday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
    { no: "05", course: "National Cyber Security", date: "20 Nov 2026", day: "Friday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
    { no: "06", course: "Advanced Shopify & Daraz", date: "20 Nov 2026", day: "Friday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "07", course: "Freelancing Program", date: "21 Nov 2026", day: "Saturday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "08", course: "Full Stack Graphic Designing", date: "21 Nov 2026", day: "Saturday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
    { no: "09", course: "Amazon Virtual Assistant", date: "23 Nov 2026", day: "Monday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "10", course: "Machine Learning & Data Science", date: "23 Nov 2026", day: "Monday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
    { no: "11", course: "Python Programming for Everyone", date: "24 Nov 2026", day: "Tuesday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
    { no: "12", course: "YouTube Monetization", date: "24 Nov 2026", day: "Tuesday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "13", course: "Forex Trading", date: "24 Nov 2026", day: "Tuesday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "14", course: "Search Engine Optimization - SEO", date: "25 Nov 2026", day: "Wednesday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "15", course: "WordPress", date: "25 Nov 2026", day: "Wednesday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
    { no: "16", course: "Advanced UI/UX Designing with AI for Web & App", date: "25 Nov 2026", day: "Wednesday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
    { no: "17", course: "Penetration Testing Web Hacking", date: "26 Nov 2026", day: "Thursday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "18", course: "Web Development with React & Node JS", date: "26 Nov 2026", day: "Thursday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
    { no: "19", course: "Advanced Google Ads", date: "26 Nov 2026", day: "Thursday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "20", course: "MERN Stack Web Development", date: "26 Nov 2026", day: "Thursday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
    { no: "21", course: "Textile Designing", date: "27 Nov 2026", day: "Friday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "22", course: "Digital Embroidery", date: "27 Nov 2026", day: "Friday", time: "7:00 PM – 8:30 PM", duration: "1.5 Hrs" },
    { no: "23", course: "Advanced PHP Laravel Web Development", date: "27 Nov 2026", day: "Friday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
    { no: "24", course: "Cross-Platform Flutter App Development", date: "27 Nov 2026", day: "Friday", time: "7:00 PM – 9:00 PM", duration: "2 Hrs" },
  ];

  const filteredDateSheet = dateSheetData.filter((item) =>
    item.course.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.date.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.day.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="exam-datesheet-page" style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>
      {/* Banner */}
      <div
        className="breadcrums position-relative text-white py-5"
        style={{
          background: "linear-gradient(135deg, #0d3b24 0%, #065f46 50%, #047857 100%)",
          overflow: "hidden",
        }}
      >
        <ParticleBackground />
        <div className="container position-relative" style={{ zIndex: 2 }}>
          <div className="text-center py-4">
            <span
              className="badge px-3 py-2 mb-3 text-uppercase font-12 font-md-14 text-wrap"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.15)",
                backdropFilter: "blur(6px)",
                letterSpacing: "1px",
                borderRadius: "30px",
                border: "1px solid rgba(255, 255, 255, 0.3)",
                maxWidth: "100%",
                display: "inline-block",
                wordBreak: "break-word",
                whiteSpace: "normal",
              }}
            >
              <FaGraduationCap className="me-2" />
              Hunarmand Punjab / Online Assessments Batch-1 &amp; Batch-2
            </span>
            <h1 className="fw-bold fs-2 fs-md-1 mb-2 text-white">
              Online Final Exams Date Sheet
            </h1>
            <p className="lead mb-0 text-white-50 font-16 font-md-18">
              Batch-1 &amp; Batch-2 Date Sheet | 16–27 November 2026
            </p>
          </div>
        </div>
      </div>

      <div className="container py-3 py-md-5">
        {/* Navigation Back Link */}
        <div className="mb-4 d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center gap-2">
          <Link
            to="/online-exam"
            className="btn btn-outline-dark px-3 py-2 fw-semibold d-inline-flex align-items-center justify-content-center text-center"
            style={{ borderRadius: "8px", fontSize: "14px" }}
          >
            <FaArrowLeft className="me-2" /> Back to Online Exam Rules
          </Link>
          <a
            href="https://lms.hunarmandpunjab.org.pk/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success px-4 py-2 fw-bold d-inline-flex align-items-center justify-content-center text-center shadow-sm"
            style={{ borderRadius: "8px", fontSize: "14px" }}
          >
            <FaDesktop className="me-2" /> Open LMS Portal
          </a>
        </div>

        {/* Date Sheet Card */}
        <div className="card border-0 shadow-sm overflow-hidden" style={{ borderRadius: "16px", background: "#ffffff" }}>
          {/* Card Top Details */}
          <div
            className="p-4 p-md-5 text-white"
            style={{
              background: "linear-gradient(135deg, #064e3b 0%, #047857 60%, #10b981 100%)",
            }}
          >
            <div className="row align-items-center">
              <div className="col-lg-8">
                <span
                  className="badge px-3 py-1 mb-2 text-uppercase font-12"
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                  }}
                >
                  Official Schedule
                </span>
                <h2 className="fw-bold mb-2 text-white font-28">
                  Batch-1 &amp; Batch-2 Final Exams Schedule
                </h2>
                <div className="text-white-50 font-14">
                  <span className="me-3"><strong>EXAM PERIOD:</strong> 16–27 November 2026</span>
                  <span className="me-3"><strong>EXAM MODE:</strong> Online</span>
                  <span><strong>TIME ZONE:</strong> Pakistan Standard Time (PKT)</span>
                </div>
              </div>
              <div className="col-lg-4 mt-3 mt-lg-0">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search your course..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      borderRadius: "30px",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      backgroundColor: "rgba(255, 255, 255, 0.95)",
                      fontSize: "14px",
                      padding: "10px 18px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Important Note Alert */}
          <div
            className="p-3 px-4"
            style={{
              backgroundColor: "#fef2f2",
              borderBottom: "1px solid #fee2e2",
              color: "#991b1b",
              fontSize: "14px",
              lineHeight: "1.6",
            }}
          >
            <FaExclamationTriangle className="me-2 text-danger" />
            <strong>NOTE:</strong> A student may take the final exam for <strong>ONLY ONE subject</strong>. Taking exams for <strong>TWO subjects is NOT allowed</strong>. Please note your chosen subject’s exam date and time, and log in to your student LMS Portal before the scheduled time, ready for the exam.
          </div>

          {/* Responsive Desktop Table */}
          <div className="table-responsive d-none d-md-block">
            <table className="table table-hover align-middle mb-0" style={{ fontSize: "14px" }}>
              <thead style={{ backgroundColor: "#064e3b", color: "#ffffff" }}>
                <tr>
                  <th className="py-3 px-4 text-center" style={{ width: "70px" }}>NO.</th>
                  <th className="py-3 px-4">COURSE / SUBJECT</th>
                  <th className="py-3 px-4">EXAM DATE</th>
                  <th className="py-3 px-4">DAY</th>
                  <th className="py-3 px-4">EXAM TIME (PKT)</th>
                  <th className="py-3 px-4 text-center">DURATION</th>
                </tr>
              </thead>
              <tbody>
                {filteredDateSheet.length > 0 ? (
                  filteredDateSheet.map((item, idx) => (
                    <tr key={idx} style={{ borderBottom: "1px solid #f1f5f9" }}>
                      <td className="py-3 px-4 text-center fw-bold text-muted">{item.no}</td>
                      <td className="py-3 px-4">
                        <span className="fw-bold text-dark">{item.course}</span>
                      </td>
                      <td className="py-3 px-4">
                        <span className="badge bg-light text-dark border px-2 py-1">
                          <FaCalendarAlt className="me-1 text-primary" /> {item.date}
                        </span>
                      </td>
                      <td className="py-3 px-4 text-secondary font-13 fw-semibold">{item.day}</td>
                      <td className="py-3 px-4">
                        <span className="fw-bold text-success font-13">
                          <FaClock className="me-1 text-muted" /> {item.time}
                        </span>
                      </td>
                      <td className="py-3 px-4 text-center">
                        <span
                          className="badge"
                          style={{
                            backgroundColor: item.duration.includes("2") ? "#e0e7ff" : "#fef3c7",
                            color: item.duration.includes("2") ? "#3730a3" : "#92400e",
                          }}
                        >
                          {item.duration}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-5 text-muted">
                      No courses found matching "<strong>{searchTerm}</strong>"
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile-Friendly Cards View (Under 768px) */}
          <div className="d-block d-md-none p-3">
            {filteredDateSheet.length > 0 ? (
              filteredDateSheet.map((item, idx) => (
                <div
                  key={idx}
                  className="p-3 mb-3 rounded-3 shadow-sm bg-white border"
                  style={{ borderLeft: "4px solid #047857" }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="badge bg-secondary font-12">#{item.no}</span>
                    <span
                      className="badge font-12"
                      style={{
                        backgroundColor: item.duration.includes("2") ? "#e0e7ff" : "#fef3c7",
                        color: item.duration.includes("2") ? "#3730a3" : "#92400e",
                      }}
                    >
                      {item.duration}
                    </span>
                  </div>
                  <h6 className="fw-bold text-dark mb-2">{item.course}</h6>
                  <div className="text-muted font-13 mb-1">
                    <FaCalendarAlt className="me-1 text-primary" />
                    <strong>Date:</strong> {item.date} ({item.day})
                  </div>
                  <div className="text-success font-13 fw-semibold">
                    <FaClock className="me-1 text-muted" />
                    <strong>Time:</strong> {item.time}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-4 text-muted">
                No courses found matching "{searchTerm}"
              </div>
            )}
          </div>

          <div className="p-3 bg-light text-center border-top text-muted font-13">
            All examination times shown are in Pakistan Standard Time (PKT).
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamDateSheet;
